import React from "react";
import "../../css/Hero.css";
import Button from "./Button";
import { useNavigate } from "react-router-dom";

const renderLines = (text) => {
  const lines = text.split("\n");

  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};
function Hero({
  title = "",
  subtitle = "",
  backgroundImage = "",
  logo,
  titleAlign = "center", // "center" | "left"
  subtitleAlign = "center", // "center" | "left"
  lightOverlay = false,
  showButton = false,

}) {
  const navigate = useNavigate();
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className={`hero-overlay ${lightOverlay ? "light-overlay" : ""}`}>
        <div className="hero-content">
          {logo && <img src={logo} alt="Logo" className="hero-logo" />}
          <h1 className="font-hero-title" style={{ textAlign: titleAlign }}>
            {renderLines(title)}
          </h1>

          <div className={`divider align-${titleAlign}`}></div>

          <p style={{ textAlign: subtitleAlign }}>{renderLines(subtitle)}</p>

          {/* {buttonText && (
            <Button
              text={buttonText}
              variant="primary"
              onClick={onButtonClick}
            />
          )} */}
          {showButton && (
            <div className={`button-group align-${titleAlign}`}>
              <Button
                text="ABOUTS US"
                variant="primary"
                onClick={
                  () => navigate("/about")

                }
              />
              <Button
                text="CONTACT US"
                variant="secondary"
                onClick={
                  () => navigate("/contact")
                }
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Hero;
